<template src="./restrictionsSummaryPanel.template.html"></template>
<script>
import moment from "moment-timezone";

export default {
  name: "restrictionsSummaryPanel",
  props: ["showRestrictionSummeryPannel", "parentCallback", "hideSummaryPanel"],
  data() {
    return {
      restrictionsDetail: {
        syncRentalsUnited: null,
        RestrictionName: "",
        PropertyId: null,
        UnitId: null,
        Description: "",
        RestrictionTypeId: null,
        EffectiveDates: []
      },
      propertyList: [],
      unitList: [],
      isSummaryLoading: false,
      filterObj: {
        SortBy: null,
        SortOrder: null
      },
      restrictionsList: [],
      propertyList: [],
      headerColumnList: [],
      toggleFilterPanel: false,
      headerColumnList: {
        PROPERTYNAME: {
          Label: "PROPERTY NAME",
          IsChecked: true,
          ColumnName: "PropertyName",
          isSortLoading: false,
          isAscOrDesc: null
        },
        UNITNAME: {
          Label: "UNIT NAME",
          IsChecked: true,
          ColumnName: "UnitName",
          class: "filterLoad",
          isSortLoading: false,
          isAscOrDesc: null
        },
        RESTRICTIONNAME: {
          Label: "RESTRICTION NAME",
          IsChecked: true,
          ColumnName: "RestrictionName",
          class: "filterLoad",
          isSortLoading: false,
          isAscOrDesc: null
        },
        RESTRICTIONTYPE: {
          Label: "RESTRICTION TYPE",
          IsChecked: true,
          ColumnName: "RestrictionTypeName",
          class: "filterLoad",
          isSortLoading: false,
          isAscOrDesc: null
        }
      },

      filterObj: {
        SortBy: null,
        SortOrder: null
      },
      restrictionsDetailIdObj: {},
      restrictionsDetails: false
    };
  },
  methods: {
    showRestrictionsSummaryPanel() {
      let vm = this;
      // console.log("inst", inst);
      vm.restrictionsDetails = false;
      $("#restrictionsSummary").addClass("expand");
      $(".clientList").removeClass("expand");
      $("#notification").removeClass("expand");
      $(".reservationSummary").removeClass("expand");
      $("#ratesSummary").removeClass("expand");
      $(".menuMaskRestrictionSum").toggle();
      $("#restrictionsSummary").removeClass("menuMaskRestrictionSum");
      vm.isSummaryLoading = true;
      vm.getRestrictionsList();
      $(this.$el)
        .find("ul.dropdown-menu")
        .click(function(e) {
          e.stopPropagation();
        });
    },
    closeSummaryPannel() {
      let vm = this;
      $(".menuMaskRestrictionSum").hide();
      $("#restrictionsSummary").removeClass("expand");
      if (vm.hideSummaryPanel) {
        vm.hideSummaryPanel();
      }
    },
    tapChartCallBackFunction() {
      let vm = this;
      if (vm.parentCallback) {
        vm.parentCallback();
      }
    },
    closeFilter: function() {
      this.toggleFilterPanel = false;
    },

    ascSort(sortBy, sortOrder) {
      let vm = this;
      vm.filterObj.SortBy = sortBy;
      vm.filterObj.SortOrder = sortOrder;
      for (var i in vm.headerColumnList) {
        if (vm.headerColumnList[i].ColumnName !== "LOGO") {
          var obj = vm.headerColumnList[i];
          console.log("obj", obj);
          // for (var j in obj.sortLabels) {
          if (sortBy.toString() === obj.ColumnName) {
            console.log("obj.ColumnName", obj.ColumnName);
            vm.headerColumnList[i].isSortLoading = true;
            vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
            //   }
            // }
          }
        }
      }

      vm.getRestrictionsList();
      // for (var i in vm.headerColumnList) {

      //     var obj = vm.headerColumnList[i];
      //     console.log("obj", obj)
      //     if (sortBy.toString() === obj.ColumnName) {
      //         console.log("obj.ColumnName", obj.ColumnName);
      //         vm.headerColumnList[i].isSortLoading = true;
      //         vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
      //     }
      // }

      //vm.getReservationsList(vm.propertyId, vm.UnitClassId, vm.ViewListId, SortBy, SortOrder, vm.sourceID);
    },
    getRestrictionsList: function() {
      let scope = this;
      this.$store.dispatch("dataRequestHandler", {
        key: "GetRestrictionList",
        params: {
          filterObj: scope.filterObj
        },
        callback: function(err, response) {
          if (response) {
            scope.restrictionsList.splice(
              0,
              scope.restrictionsList.length,
              ...response.restrictionsList
            );
            scope.propertyList.splice(
              0,
              scope.propertyList.length,
              ...response.propertyList
            );
            // if (scope.restrictionsList.length > 0) {
            //     scope.$store.dispatch("toastr", {
            //         type: "success",
            //         header: "Success!",
            //         message: "restrictionsList  Rendered"
            //     });
            // }
            scope.isSummaryLoading = false;
            for (var i in scope.headerColumnList) {
              if (scope.headerColumnList[i].ColumnName !== "LOGO") {
                var obj = scope.headerColumnList[i];
                console.log("obj", obj);

                if (scope.filterObj.SortBy === obj.ColumnName.toString()) {
                  console.log("obj.ColumnName", obj.ColumnName);
                  scope.headerColumnList[i].isSortLoading = false;
                  // vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
                }
              }
            }
          } else {
            console.log(err);
          }
        }
      });
    },
    navigateToNewRestrictionDetails(restrictionId) {
      console.log(restrictionId);
      this.restrictionsDetailIdObj = {
        restrictionId: restrictionId
      };
      this.restrictionsDetails = true;
      //   this.$router.push(
      //     "/restrictionDetail/" + (restrictionId ? restrictionId : -1)
      //   );
    },
    hideDetailSummary() {
      let vm = this;
      vm.restrictionsDetails = false;
      vm.getRestrictionsList();
    }
  },
  computed: {},
  mounted() {
    let vm = this;
    console.log("show pannel 1");
    // vm.$store.state.bus.$on("showPanel", function(param) {
    //   console.log("show pannel 2");
    //   if (param) {
    //     console.log("show pannel 3");
    //     vm.showRestrictionsSummaryPanel();
    //   }
    // });
    // this.getRestrictionsList();
  },
  watch: {
    showRestrictionSummeryPannel: {
      handler: function(resObj, oldVal) {
        if (resObj == true) {
          this.showRestrictionsSummaryPanel();
        }
      },
      deep: true
    }
  },
  destroyed() {}
};
</script>